import { createShader, colorUniform } from "./ShaderBase.js";

export const synthwaveShader = createShader({
  customizable: [
    { uniform: "uColorSky", label: "Sky", default: "#0d0221" },
    { uniform: "uColorNeon", label: "Neon", default: "#ff00ff" },
  ],

  uniforms: {
    uPixelSize: { value: 14.0 },
    uScale: { value: 1.0 },
    uSpeed: { value: 0.3 },
    uColorSky: colorUniform("#0d0221"),
    uColorNeon: colorUniform("#ff00ff"),
    uColorCyan: colorUniform("#00ffff"),
    uColorSun: colorUniform("#ff6b35"),
    uGridIntensity: { value: 0.8 },
  },

  fragmentUniforms: `
    uniform vec3 uColorSky;
    uniform vec3 uColorNeon;
    uniform vec3 uColorCyan;
    uniform vec3 uColorSun;
    uniform float uGridIntensity;
  `,

  fragmentBody: `
    // Base gradient - dark sky
    vec3 color = uColorSky;

    // Sun glow at bottom
    float sunGlow = 1.0 - (pixelatedPos.y * 0.015 + 0.3);
    sunGlow = clamp(sunGlow, 0.0, 1.0);
    sunGlow = pow(sunGlow, 2.0);
    color = mix(color, uColorSun, sunGlow * 0.4);

    // Retro grid lines
    float gridX = abs(fract(pixelatedPos.x * 0.1 + 0.5) - 0.5);
    float gridY = abs(fract(pixelatedPos.z * 0.1 + uTime * uSpeed + 0.5) - 0.5);

    float lineX = 1.0 - smoothstep(0.0, 0.08, gridX);
    float lineY = 1.0 - smoothstep(0.0, 0.08, gridY);

    // Grid fades with height (perspective effect)
    float gridFade = clamp(1.0 - pixelatedPos.y * 0.02, 0.0, 1.0);
    float grid = max(lineX, lineY) * gridFade * uGridIntensity;

    // Alternate neon colors on grid
    float colorSwitch = step(0.5, fract(pixelatedPos.x * 0.05 + uTime * 0.1));
    vec3 gridColor = mix(uColorNeon, uColorCyan, colorSwitch);
    color = mix(color, gridColor, grid * 0.9);

    // Horizontal scanlines
    float scan = step(0.5, fract(pixelatedPos.y * 1.5));
    color *= 0.92 + scan * 0.08;

    // Neon glow pulse
    float pulse = sin(uTime * uSpeed * 3.0) * 0.5 + 0.5;
    color += gridColor * grid * pulse * 0.2;

    gl_FragColor = vec4(color, 1.0);
  `,
});
